export let Config = {
  apiRoot: null,
  languagesApi: 'languages',

  workflowActionApi: 'workflow/action',
  listApi: 'list',
  logicApi: 'logic/',
  businessApi: 'business/',
  formApi: 'form/',

  loginPath: 'login',
  logoutPath: 'logout',
  profilePath: 'profile',
  workflowDataVersionPath: 'workflow/data_version',

  dateFormat: 'yyyy/MM/dd',
  dateTimeFormat: 'yyyy/MM/dd HH:mm:ss',

  prod: null
};
